import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import EnhancedTable from '../../widgets/ResponsiveTable';
import EnhancedToolbar from '../../widgets/Toolbar';
import AlertItem from "../../widgets/AlertItem";
import Prompt from '../../widgets/Prompt';
import ViewUtils from '../../ViewUtils';
import { ViewContainer } from "./../../View.jsx";
import IIBTCPSetupSearch from "../program/IIBTCP/IIBTCPSetupSearch";
import LinkDialog from "../LinkDialog";
import withMenuPermission from "../../widgets/withMenuPermission";

const headCells = [
    { id: 'IIBTCPCode', numeric: false, disablePadding: false, label: 'Programme Code' },
    { id: 'IIBTCPDescription', numeric: false, disablePadding: false, label: 'Programme Description' },
    { id: 'RegistrationStartDate', numeric: false, disablePadding: false, label: 'Registration Start Date' },
    { id: 'RegistrationEndDate', numeric: false, disablePadding: false, label: 'Registration End Date' }


];

const utils = new ViewUtils();
const toolbarRef = React.createRef();
const addFormRef = React.createRef();

class AgentIIBTCPSearch extends Component {

    constructor(props) {
        super(props)
        this.state = {
            selectedIIBTCP: null,
            linkDialogOpen: false,
            formDialogOpen: false,
            auditDialogOpen: false,
            searchParameters: [{ Name: "AgentID", Value: this.props.location.state.selection }],
            propmtOpen: false,
            promptTitle: "Remove Programme from Agent",
            promptContent: "Are you sure you want to remove this Programme from the agent?",
            removeMessage: "",
            removeMessageStyle: "",
            Message: "",
            showTable: true

        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: "link", label: '', icon: 'LinkIcon', tooltip: "Link Programme to agent", visible: this.props.menuPermissionItem.Add },
                        {
                            id: 'remove', label: '', icon: 'DeleteIcon', tooltip: 'Remove Programme from Agent',
                            disabled: utils.isNull(this.state.selectedIIBTCP), visible: this.props.menuPermissionItem.Delete
                        }
                    ]
                }
            ]
        };

    }
    handleToolbarButtonClick(buttonId) {
        if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/agent',
                state: { selection: this.props.location.state.selection }
            });
        }
        else if ("remove" === buttonId) {
            this.setState({ promptOpen: true })
        }
        else if ("link" === buttonId) {
            this.setState({ linkDialogOpen: true, removeMessage: "" })

        }
    }

    dialogActionHandler(isCancel, added) {
        if (added === true) {
            this.setState({
                showTable: false,
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                formDialogOpen: false, selectedSiteVisit: null, auditDialogOpen: false, linkDialogOpen: false, selection: this.props.location.state.selection, selectedIIBTCP: null
            }, () => {
                this.setState({ showTable: true })
            });
        }
        else if (isCancel === true) {
            this.setState({
                formDialogOpen: false,
                linkDialogOpen: false,
                auditDialogOpen: false
            })
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedIIBTCP: selection[0].Id, removeMessage: "" });
        }
        else {
            this.setState({ selectedIIBTCP: null, removeMessage: "" })
        }
        toolbarRef.current.setButtonDisabled("remove", selection === null || selection.length === 0);
    }

    successfulRemoveCallback = (response) => {

        if (!utils.isNull(response.EntityId) && response.EntityId === 0) {
            this.setState({
                selectedIIBTCP: null,
                removeMessage: response.Message,
                removeMessageStyle: response.MessageType.toLowerCase()
            });
            //Force a refresh
            this.setState({ searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)) })
        }
    }

    unsuccessfulRemoveCallback = (response) => {
        if (!utils.isNull(response.Message) && response.Message !== "") {
            this.setState({
                removeMessage: response.Message,
                removeMessageStyle: response.MessageType.toLowerCase()
            })
        }
    }

    removeIIBTCPs(url) {
        this.setState({ promptOpen: false }, () => {
            toolbarRef.current.setButtonDisabled("remove", true);
            toolbarRef.current.setButtonDisabled("view", true);
        })


        let fullUrl = `${url}?id=${this.state.selectedIIBTCP}&agentId=${this.props.location.state.selection}`;
        utils.invokeUrlDelete(fullUrl, this.successfulRemoveCallback, this.unsuccessfulRemoveCallback);
    }


    closePrompt = () => {
        this.setState({ propmtOpen: false })
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">

                <p className="breadcrumbs">
                    {"Agent > Inhouse/Industry/Based Training Programme " + (this.props.location.state.agentName !== null ? "> " + this.props.location.state.agentName + (this.props.location.state.agentSDLNumber !== null ? " - " + this.props.location.state.agentSDLNumber : "") : "> Add")}
                </p>

                <AlertItem message={this.state.removeMessage} alertStyle={this.state.removeMessageStyle} />

                <div className="searchResults">
                    <EnhancedToolbar
                        highlight={false}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        ref={toolbarRef}
                        config={this.toolbarConfig} />

                    {this.state.showTable === true && (

                        <EnhancedTable
                            headCells={headCells}
                            dataUrl={`api/sims/agentIIBTCP/GetAgentIIBTCPs`}
                            onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                            searchParameters={this.state.searchParameters} paged={true} />
                    )}
                </div>

                <LinkDialog
                    open={this.state.linkDialogOpen}
                    closeHandler={(isCancelled, linked) => this.dialogActionHandler(isCancelled, linked)}
                    dialogTitle={`Link Programme/s to Agent > ${this.props.location.state.agentName} - ${this.props.location.state.agentSDLNumber}`}
                    linkName={"IIBTCP"} postUrl={"api/sims/agentIIBTCP/LinkAgentIIBTCP"} usePost={true}
                    selectionId={this.props.location.state.selection}
                >
                    <IIBTCPSetupSearch
                        dataUrl="api/sims/agentIIBTCP/GetSearchLinkableIIBTCPs"
                        mode="lookup"
                        multiSelect={true} showTitle={false}
                        programmeId={this.props.location.state.selection}
                    />
                </LinkDialog>

                <Prompt open={this.state.promptOpen}
                    promptTitle={this.state.promptTitle}
                    promptContent={this.state.promptContent}
                    handleYes={() => { this.removeIIBTCPs("api/sims/agentIIBTCP/RemoveAgentIIBTCP") }}
                    closePrompt={this.closePrompt}
                />
            </ViewContainer>
        );
    }
}

export default withRouter(withMenuPermission(AgentIIBTCPSearch));
